(function () {
  if (window.__fbCardEnhancementsLoaded) return;
  window.__fbCardEnhancementsLoaded = true;

  /* ---------- Wishlist (client-side, stored in this browser only) ---------- */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('fb_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem('fb_wishlist', JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable, fail silently */
    }
  }

  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = list.indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    setWishlist(list);
    refreshWishlistButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshWishlistButtons);
  } else {
    refreshWishlistButtons();
  }

  /* ---------- Quick view ---------- */
  var quickViewRoot;

  function ensureModal() {
    if (quickViewRoot) return quickViewRoot;
    quickViewRoot = document.createElement('div');
    quickViewRoot.className = 'quick-view-overlay';
    quickViewRoot.innerHTML =
      '<div class="quick-view-overlay__backdrop" data-quick-view-close></div>' +
      '<div class="quick-view-overlay__panel" role="dialog" aria-modal="true">' +
      '<button class="quick-view-overlay__close" type="button" data-quick-view-close aria-label="Close">&times;</button>' +
      '<div class="quick-view-overlay__body"></div>' +
      '</div>';
    document.body.appendChild(quickViewRoot);
    quickViewRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-quick-view-close]')) {
        closeQuickView();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });
    return quickViewRoot;
  }

  function closeQuickView() {
    if (quickViewRoot) quickViewRoot.classList.remove('is-open');
    document.body.classList.remove('quick-view-open');
  }

  function openQuickView(url) {
    var root = ensureModal();
    var body = root.querySelector('.quick-view-overlay__body');
    body.innerHTML = '<div class="quick-view-overlay__loading">Loading&hellip;</div>';
    root.classList.add('is-open');
    document.body.classList.add('quick-view-open');
    fetch(url + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        renderQuickView(body, product, url);
      })
      .catch(function () {
        body.innerHTML =
          '<p class="quick-view-overlay__loading">Sorry, this product could not be loaded. <a href="' +
          url +
          '">View product page</a></p>';
      });
  }

  function money(cents) {
    return (cents / 100).toFixed(2);
  }

  function renderQuickView(body, product, url) {
    var variant = product.variants[0];
    var img = product.featured_image || (product.images && product.images[0]);
    var optionsHtml = '';
    if (product.variants.length > 1) {
      optionsHtml =
        '<select class="quick-view-overlay__variant-select">' +
        product.variants
          .map(function (v) {
            return (
              '<option value="' +
              v.id +
              '"' +
              (v.available ? '' : ' disabled') +
              '>' +
              v.title +
              (v.available ? '' : ' - Sold out') +
              '</option>'
            );
          })
          .join('') +
        '</select>';
    }
    body.innerHTML =
      '<div class="quick-view-overlay__media">' +
      (img ? '<img src="' + img + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="quick-view-overlay__info">' +
      '<h2 class="quick-view-overlay__title">' +
      product.title +
      '</h2>' +
      '<div class="quick-view-overlay__price">' +
      (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s> ' : '') +
      '<strong>' +
      money(variant.price) +
      '</strong>' +
      '</div>' +
      optionsHtml +
      '<button type="button" class="button button--full-width quick-view-overlay__add"' +
      (variant.available ? '' : ' disabled') +
      '>' +
      (variant.available ? 'Add to cart' : 'Sold out') +
      '</button>' +
      '<a href="' +
      url +
      '" class="quick-view-overlay__link">View full details</a>' +
      '</div>';

    var select = body.querySelector('.quick-view-overlay__variant-select');
    var addBtn = body.querySelector('.quick-view-overlay__add');
    var currentVariantId = variant.id;

    if (select) {
      select.addEventListener('change', function () {
        currentVariantId = select.value;
        var v = product.variants.filter(function (vv) {
          return String(vv.id) === String(currentVariantId);
        })[0];
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
    }

    addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: 1 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          addBtn.textContent = 'Added';
          return fetch('/cart.js');
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var bubbleText = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubbleText) bubbleText.textContent = cart.item_count;
          var bubble = document.querySelector('.cart-count-bubble');
          if (bubble) bubble.hidden = cart.item_count === 0;
          setTimeout(closeQuickView, 900);
        })
        .catch(function () {
          addBtn.textContent = 'Error, try again';
          addBtn.disabled = false;
        });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view-url]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openQuickView(btn.getAttribute('data-quick-view-url'));
  });
})();
